import { type DocBlock } from './_Doc.ts'
import { type EMRKindID, type EMRTypeID } from './_EMR.ts'
import { NORMAL_TEXT, TITLE, TokenStream } from './_parsing.ts'

export const PinnedNote_ID = 'imago.user-pinned-note' as EMRTypeID & EMRKindID

export interface UserPinnedNoteContent {
	notes: string
}

export function docifyPinnedNote(pn: UserPinnedNoteContent): DocBlock[] {
	return [
		{ class: TITLE, text: "Pinned Note" },
		{ class: NORMAL_TEXT, text: pn.notes },
	]
}

export function parsePinnedNote(md: DocBlock[]): UserPinnedNoteContent {
	const ts = new TokenStream(md[Symbol.iterator]())

	ts.match(TITLE, "Pinned Note")
	const notes = ts.consumePlainContent()

	const pn: UserPinnedNoteContent = { notes }
	return pn
}
